import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useStyles } from './ButtonCard.styles';
export const ButtonCard = (props) => {
    const classes = useStyles();
    const AsLink = React.forwardRef((linkProps, ref) => {
        const styles = [classes.root, ...(linkProps.disabled ? [classes.disabled] : [])];
        return (React.createElement(React.Fragment, null, !props.disabled ? (React.createElement(Link, Object.assign({ component: RouterLink, to: !props.disabled && props.to, sx: styles, ref: ref }, linkProps), props.children)) : (React.createElement(Box, Object.assign({ component: "span", sx: styles }, linkProps), props.children))));
    });
    const AsExternalLink = React.forwardRef((linkProps, ref) => {
        const styles = [classes.root, ...(linkProps.disabled ? [classes.disabled] : [])];
        return (React.createElement(React.Fragment, null, !props.disabled ? (React.createElement(Link, { component: "a", href: !props.disabled && props.toExternal, sx: styles, ref: ref }, props.children)) : (React.createElement(Box, Object.assign({ component: "span", sx: styles }, linkProps), props.children))));
    });
    const AsButton = (asButtonProps) => {
        const styles = [
            classes.root,
            classes.button,
            ...(asButtonProps.disabled ? [classes.disabled] : []),
        ];
        return (React.createElement(Button, { disableFocusRipple: true, disabled: asButtonProps.disabled, onClick: asButtonProps.onClick, sx: styles }, asButtonProps.children));
    };
    if (props.to && !props.onClick) {
        return React.createElement(AsLink, Object.assign({}, props));
    }
    else if (props.toExternal && !props.onClick) {
        return React.createElement(AsExternalLink, Object.assign({}, props));
    }
    else {
        return React.createElement(AsButton, Object.assign({}, props));
    }
};
export default ButtonCard;
